<div mat-dialog-title class="dashboard-einstallen-stepper__header">
    <h1 class="dashboard-einstallen-stepper__title">{{ dialogTitle }}</h1>
    <button
        mat-icon-button
        type="button"
        class="dashboard-einstallen-stepper__close"
        aria-label="Dialog schließen"
        (click)="close()"
    >
        <mat-icon>close</mat-icon>
    </button>
</div>

<div
    mat-dialog-content
    class="dashboard-einstallen-stepper__dialog-content"
    [class.dashboard-einstallen-stepper__dialog-content--einstallen-scroll]="useDialogContentScrollLayout"
    [class.dashboard-einstallen-stepper__dialog-content--picker-flex]="useDialogContentFlexLayout"
    [class.dashboard-einstallen-stepper__dialog-content--initializing]="isPrefillInitializing"
>
    <div class="dashboard-einstallen-stepper__content-shell">
        <div *ngIf="showStepperWorkflow" class="dashboard-einstallen-stepper__workflow">
        <nav
            *ngIf="showCompactStepNav"
            class="dashboard-einstallen-stepper__compact-nav"
            aria-label="Schritte"
        >
            <ol class="dashboard-einstallen-stepper__compact-nav-list">
                <li
                    *ngFor="let item of compactStepNavItems; let last = last"
                    class="dashboard-einstallen-stepper__compact-nav-item"
                    [class.dashboard-einstallen-stepper__compact-nav-item--done]="item.state === 'done'"
                    [class.dashboard-einstallen-stepper__compact-nav-item--current]="item.state === 'current'"
                    [class.dashboard-einstallen-stepper__compact-nav-item--upcoming]="
                        item.state === 'upcoming' || item.state === 'reachable'
                    "
                    [class.dashboard-einstallen-stepper__compact-nav-item--reachable]="item.state === 'reachable'"
                >
                    <button
                        type="button"
                        class="dashboard-einstallen-stepper__compact-nav-btn"
                        [disabled]="!item.clickable"
                        [attr.aria-current]="item.state === 'current' ? 'step' : null"
                        (click)="goToCompactStep(item.index)"
                    >
                        <span class="dashboard-einstallen-stepper__compact-nav-marker" aria-hidden="true">
                            <mat-icon *ngIf="item.state === 'done'">check</mat-icon>
                            <span *ngIf="item.state !== 'done'">{{ item.displayNumber }}</span>
                        </span>
                        <span class="dashboard-einstallen-stepper__compact-nav-label">{{ item.label }}</span>
                    </button>
                    <mat-icon *ngIf="!last" class="dashboard-einstallen-stepper__compact-nav-sep" aria-hidden="true">
                        chevron_right
                    </mat-icon>
                </li>
            </ol>
        </nav>

        <div
            *ngIf="isAbgangZielPickerStepActive"
            class="dashboard-einstallen-stepper__outside-picker dashboard-einstallen-stepper__step-body dashboard-einstallen-stepper__step-body--abgang-ziel-picker"
        >
            <ng-container *ngIf="isOnEmpfaengerStepActive">
                <p class="dashboard-einstallen-stepper__intro">
                    Wählen Sie optional einen Empfänger (Kontakt oder Schlachthof), bevor Sie Tiere zur Liste hinzufügen.
                    Sie können diesen Schritt auch überspringen.
                </p>

                <p *ngIf="isPreparingTierauswahlAbgang" class="dashboard-einstallen-stepper__state">
                    Ausstallliste wird vorbereitet…
                </p>

                <kiene-ausstallen-empfaenger-dialog
                    *ngIf="!isPreparingTierauswahlAbgang && empfaengerEmbeddedTierliste"
                    #embeddedEmpfaengerPicker
                    class="dashboard-einstallen-stepper__empfaenger-embedded"
                    [embeddedInStepper]="true"
                    flowType="ausstallen_extern"
                    [stepperTierliste]="empfaengerEmbeddedTierliste"
                    [stepperGruppeKundeId]="gruppe?.kunde_id ?? getStepperInhaberKundeId() ?? undefined"
                    (empfaengerSaved)="applyEmpfaengerDialogResult($event)"
                ></kiene-ausstallen-empfaenger-dialog>
            </ng-container>

            <ng-container *ngIf="isOnZielbetriebStepActive">
                <p class="dashboard-einstallen-stepper__intro">
                    Wählen Sie optional den Betrieb, in den die Tiere umgestallt werden sollen (eigene und freigegebene
                    Betriebe). Sie können diesen Schritt auch überspringen.
                </p>

                <p *ngIf="isPreparingTierauswahlAbgang" class="dashboard-einstallen-stepper__state">
                    Ausstallliste wird vorbereitet…
                </p>

                <kiene-ausstallen-empfaenger-dialog
                    *ngIf="!isPreparingTierauswahlAbgang && empfaengerEmbeddedTierliste"
                    #embeddedZielbetriebPicker
                    class="dashboard-einstallen-stepper__empfaenger-embedded"
                    [embeddedInStepper]="true"
                    flowType="umstallen_intern"
                    [stepperTierliste]="empfaengerEmbeddedTierliste"
                    [stepperGruppeKundeId]="gruppe?.kunde_id ?? getStepperInhaberKundeId() ?? undefined"
                    [stepperInhaberKundeId]="getStepperInhaberKundeId()"
                    (empfaengerSaved)="applyZielbetriebDialogResult($event)"
                ></kiene-ausstallen-empfaenger-dialog>
            </ng-container>
        </div>

        <mat-stepper
        #stepper
        [linear]="false"
        orientation="vertical"
        (selectionChange)="stepChanged($event)"
        class="dashboard-einstallen-stepper__stepper dashboard-einstallen-stepper__stepper--compact-nav"
        [class.dashboard-einstallen-stepper__stepper--continue-scan]="isContinuePrefilledMode"
        [class.dashboard-einstallen-stepper__stepper--body-hidden]="isAbgangZielPickerStepActive"
    >
        <mat-step *ngIf="!isContinuePrefilledMode" [completed]="hasClientChosen">
            <ng-template matStepLabel>Kunde</ng-template>

            <div *ngIf="isActiveStep(ix.kunde)" class="dashboard-einstallen-stepper__step-body">
                <p class="dashboard-einstallen-stepper__intro">
                    Wählen Sie den Betrieb, für den die Aktion ausgeführt werden soll.
                </p>

                <ng-container *ngIf="hasClientChosen; else kundeBetriebAuswahl">
                    <button
                        *ngIf="canChangeClient; else kundeBetriebReadonly"
                        type="button"
                        class="dashboard-einstallen-stepper__selection-card dashboard-einstallen-stepper__selection-card--button"
                        (click)="openClientDialog()"
                    >
                        <div class="dashboard-einstallen-stepper__selection-label">Aktueller Betrieb</div>
                        <div>{{ getClientDisplay(selectedClient) }}</div>
                    </button>
                    <ng-template #kundeBetriebReadonly>
                        <div class="dashboard-einstallen-stepper__selection-card">
                            <div class="dashboard-einstallen-stepper__selection-label">Aktueller Betrieb</div>
                            <div>{{ getClientDisplay(selectedClient) }}</div>
                        </div>
                    </ng-template>
                </ng-container>

                <ng-template #kundeBetriebAuswahl>
                    <div *ngIf="canChangeClient; else kundeBetriebNichtErlaubt" class="dashboard-einstallen-stepper__selection-card">
                        <div class="dashboard-einstallen-stepper__selection-label">Betrieb</div>
                        <div>Bitte wählen Sie den Betrieb für diese Aktion.</div>
                        <div class="dashboard-einstallen-stepper__selection-actions">
                            <button mat-flat-button color="accent" type="button" (click)="openClientDialog()">
                                Betrieb auswählen
                            </button>
                        </div>
                    </div>
                    <ng-template #kundeBetriebNichtErlaubt>
                        <div class="dashboard-einstallen-stepper__warning">
                            Es ist kein aktueller Betrieb ausgewählt und Sie dürfen den Betrieb hier nicht wechseln.
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </mat-step>

        <mat-step *ngIf="!isContinuePrefilledMode" [completed]="hasActionChosen">
            <ng-template matStepLabel>Aktion</ng-template>

            <div *ngIf="isActiveStep(ix.aktion)" class="dashboard-einstallen-stepper__step-body">
                <p class="dashboard-einstallen-stepper__intro">Was möchten Sie tun?</p>

                <div class="dashboard-einstallen-stepper__action-list">
                    <button
                        *ngFor="let opt of visibleActionOptions"
                        type="button"
                        mat-stroked-button
                        color="accent"
                        class="dashboard-einstallen-stepper__action-card"
                        [class.dashboard-einstallen-stepper__action-card--active]="selectedAction === opt.action"
                        (click)="waehleAktion(opt.action)"
                    >
                        <mat-icon class="dashboard-einstallen-stepper__action-icon">{{ opt.icon }}</mat-icon>
                        <span class="dashboard-einstallen-stepper__action-text">
                            <span class="dashboard-einstallen-stepper__action-title">{{ opt.title }}</span>
                            <span class="dashboard-einstallen-stepper__action-desc">{{ opt.description }}</span>
                        </span>
                    </button>
                </div>

                <div *ngIf="visibleActionOptions.length === 0" class="dashboard-einstallen-stepper__warning">
                    Für Ihren Benutzer ist keine Aktion verfügbar.
                </div>

            </div>
        </mat-step>

        <mat-step *ngIf="showTierlisteAuswahlStep" [completed]="hasTierlisteChoice">
            <ng-template matStepLabel>Liste wählen</ng-template>

            <div
                *ngIf="ix.tierlisteAuswahl !== null && isActiveStep(ix.tierlisteAuswahl)"
                class="dashboard-einstallen-stepper__step-body"
            >
                <p class="dashboard-einstallen-stepper__intro">
                    Möchten Sie Tiere zu einer bestehenden Liste hinzufügen oder eine neue Liste erstellen?
                </p>

                <div class="dashboard-einstallen-stepper__action-list">
                    <button
                        type="button"
                        mat-stroked-button
                        color="accent"
                        class="dashboard-einstallen-stepper__action-card"
                        [class.dashboard-einstallen-stepper__action-card--active]="tierlisteMode === 'new'"
                        (click)="waehleTierlisteMode('new')"
                    >
                        <mat-icon class="dashboard-einstallen-stepper__action-icon">playlist_add</mat-icon>
                        <span class="dashboard-einstallen-stepper__action-text">
                            <span class="dashboard-einstallen-stepper__action-title">Neue Liste erstellen</span>
                            <span class="dashboard-einstallen-stepper__action-desc">Neue {{ ausstallenActionLabel }}-Liste anlegen</span>
                        </span>
                    </button>

                    <button
                        type="button"
                        mat-stroked-button
                        color="accent"
                        class="dashboard-einstallen-stepper__action-card"
                        [class.dashboard-einstallen-stepper__action-card--active]="tierlisteMode === 'existing'"
                        [disabled]="bestehendeTierlistenLoaded && bestehendeTierlisten.length === 0"
                        (click)="waehleTierlisteMode('existing')"
                    >
                        <mat-icon class="dashboard-einstallen-stepper__action-icon">playlist_add_check</mat-icon>
                        <span class="dashboard-einstallen-stepper__action-text">
                            <span class="dashboard-einstallen-stepper__action-title">Bestehende Liste verwenden</span>
                            <span class="dashboard-einstallen-stepper__action-desc">
                                Tiere in offene Liste einfügen
                            </span>
                        </span>
                    </button>
                </div>

                <div *ngIf="showBestehendeTierlistenLoading" class="dashboard-einstallen-stepper__state">Lade bestehende Listen...</div>

                <div
                    *ngIf="canShowBestehendeTierlistenCards"
                    class="dashboard-einstallen-stepper__group-list"
                >
                    <button
                        *ngFor="let tierliste of bestehendeTierlisten"
                        mat-stroked-button
                        type="button"
                        class="dashboard-einstallen-stepper__group-card"
                        [class.dashboard-einstallen-stepper__group-card--active]="selectedBestehendeTierliste?.tierliste_id === tierliste.tierliste_id"
                        (click)="waehleBestehendeTierliste(tierliste)"
                    >
                        <span class="dashboard-einstallen-stepper__group-card-title">Liste #{{ tierliste.tierliste_id }}</span>
                        <span class="dashboard-einstallen-stepper__group-card-count">
                            Tiere: {{ getTierlisteTiereAnzeige(tierliste) }}
                        </span>
                        <span class="dashboard-einstallen-stepper__group-card-count">
                            Gruppe: {{ getBestehendeTierlisteGruppeLabel(tierliste) }}
                        </span>
                        <span class="dashboard-einstallen-stepper__group-card-bemerkung">
                            <span class="dashboard-einstallen-stepper__group-card-bemerkung-label">Bemerkung:</span>
                            <span
                                class="dashboard-einstallen-stepper__group-card-bemerkung-text"
                                [attr.title]="getBestehendeTierlisteBemerkung(tierliste) || null"
                            >
                                {{ getBestehendeTierlisteBemerkung(tierliste) || '—' }}
                            </span>
                        </span>
                    </button>
                </div>

                <div
                    *ngIf="
                        tierlisteMode === 'existing' &&
                        !showBestehendeTierlistenLoading &&
                        !canShowBestehendeTierlistenCards &&
                        bestehendeTierlistenLoaded &&
                        !isTierlistenStepRefreshPending
                    "
                    class="dashboard-einstallen-stepper__state"
                >
                    Keine offene bestehende Liste gefunden. Bitte neue Liste erstellen.
                </div>

            </div>
        </mat-step>

        <mat-step *ngIf="!isContinuePrefilledMode" [completed]="hasGruppeChosen">
            <ng-template matStepLabel>Gruppe</ng-template>

            <div *ngIf="isActiveStep(ix.gruppe)" class="dashboard-einstallen-stepper__step-body">
                <div class="dashboard-einstallen-stepper__group-header">
                    <p class="dashboard-einstallen-stepper__intro">{{ gruppeStepIntro }}</p>
                    <button
                        mat-mini-fab
                        color="accent"
                        type="button"
                        class="dashboard-einstallen-stepper__group-add-button"
                        aria-label="Neue Gruppe erstellen"
                        matTooltip="Neue Gruppe erstellen"
                        [disabled]="!hasClientChosen || isLoadingGruppen || isLoadingGruppe"
                        (click)="createNeueGruppe()"
                    >
                        <mat-icon>add</mat-icon>
                    </button>
                </div>

                <div *ngIf="!hasActionChosen" class="dashboard-einstallen-stepper__state">
                    Bitte zuerst eine Aktion auswählen.
                </div>

                <div *ngIf="isLoadingGruppen" class="dashboard-einstallen-stepper__state">
                    Lade Gruppen...
                </div>

                <div *ngIf="hasActionChosen && !isLoadingGruppen && gruppen.length === 0" class="dashboard-einstallen-stepper__state">
                    Für diesen Betrieb sind keine Gruppen vorhanden.
                </div>

                <div *ngIf="!isLoadingGruppen && gruppen.length > 0" class="dashboard-einstallen-stepper__group-list">
                    <button
                        *ngIf="showTierQuelleGlobalOption"
                        mat-stroked-button
                        type="button"
                        class="dashboard-einstallen-stepper__group-card dashboard-einstallen-stepper__group-card--global"
                        [class.dashboard-einstallen-stepper__group-card--active]="tierQuelleGlobal"
                        (click)="waehleTierQuelleGlobal()"
                    >
                        <span class="dashboard-einstallen-stepper__group-card-title">
                            <mat-icon class="dashboard-einstallen-stepper__group-card-global-icon">public</mat-icon>
                            Global
                        </span>
                        <span class="dashboard-einstallen-stepper__group-card-count">
                            Tiere aus allen Gruppen per Suche hinzufügen
                        </span>
                    </button>

                    <button
                        *ngFor="let item of gruppen"
                        mat-stroked-button
                        type="button"
                        class="dashboard-einstallen-stepper__group-card"
                        [class.dashboard-einstallen-stepper__group-card--active]="
                            !tierQuelleGlobal && selectedGruppe?.gruppe_id === item.gruppe_id
                        "
                        (click)="waehleGruppe(item)"
                    >
                        <span class="dashboard-einstallen-stepper__group-card-title">{{ item.bezeichnung }}</span>
                        <span class="dashboard-einstallen-stepper__group-card-count">
                            <ng-container *ngIf="isAusstallenFlow">
                                {{ formatGruppeAbschnitt(item) }}
                            </ng-container>
                            <ng-container *ngIf="!isAusstallenFlow">
                                Anzahl Tiere: {{ item.anzahl_tiere_aktuell }}
                            </ng-container>
                        </span>
                    </button>
                </div>

            </div>
        </mat-step>

        <mat-step *ngIf="showEmpfaengerStep" [completed]="hasEmpfaengerChosen">
            <ng-template matStepLabel>Empfänger</ng-template>
        </mat-step>

        <mat-step *ngIf="showZielbetriebStep" [completed]="hasZielbetriebChosen">
            <ng-template matStepLabel>Zielbetrieb</ng-template>
        </mat-step>

        <mat-step *ngIf="showTiereAuswahlStep" [completed]="hasTierauswahlForAusstallen">
            <ng-template matStepLabel>Tiere auswählen</ng-template>

            <div
                *ngIf="
                    isContinueAbgangTierlisteMode
                        ? isActiveMaterialStep('Tiere auswählen')
                        : ix.tiereAuswahl !== null && isActiveStep(ix.tiereAuswahl)
                "
                class="dashboard-einstallen-stepper__step-body dashboard-einstallen-stepper__step-body--tiere-auswahl"
            >
                <div class="dashboard-einstallen-stepper__tiere-auswahl-top">
                    <p class="dashboard-einstallen-stepper__tiere-auswahl-lead">
                        Scan, Suche oder Tiere aus der Gruppe zur {{ ausstallenActionLabel }}-Liste hinzufügen.
                    </p>
                    <span class="dashboard-einstallen-stepper__tiere-auswahl-badge">
                        {{ tierauswahlAbgangsliste?.anzahl_tiere ?? anzahlTiereInAbgangListe ?? 0 }}
                        in Liste
                    </span>
                </div>

                <p *ngIf="isPreparingTierauswahlAbgang" class="dashboard-einstallen-stepper__state">
                    Ausstallliste wird vorbereitet…
                </p>

                <div
                    *ngIf="!isPreparingTierauswahlAbgang && tierauswahlAbgangsliste"
                    class="dashboard-einstallen-stepper__tiere-auswahl-panel"
                >
                    <kiene-abgang-tier-eingabe
                        *ngIf="isTierEingabeReady"
                        [abgangsliste]="tierauswahlAbgangsliste"
                        [anzahlTiereInGruppe]="gruppe?.anzahl_tiere_aktuell ?? 0"
                        [compact]="true"
                        [stepperLayout]="true"
                        [isVisible]="true"
                        [filterGruppeId]="gruppe?.gruppe_id || tierQuelleGruppeId"
                        [tierBrowseGruppeIds]="tierBrowseGruppeIdsForEingabe"
                    ></kiene-abgang-tier-eingabe>
                </div>

            </div>
        </mat-step>

        <mat-step *ngIf="isEinstallenFlow" [completed]="last10SuccessfulScansCount > 0">
            <ng-template matStepLabel>Einstallen</ng-template>

            <div
                *ngIf="ix.workflowEinstallen !== null && isEinstallenFlow && isActiveStep(ix.workflowEinstallen)"
                class="dashboard-einstallen-stepper__step-body dashboard-einstallen-stepper__step-body--overview"
            >
                <div class="dashboard-einstallen-stepper__overview-wrap" *ngIf="showEinstallenOverview && gruppe?.gruppe_id">
                    <kiene-einstallen-uebersicht
                        class="dashboard-einstallen-stepper__overview"
                        [gruppe]="gruppe"
                        [showPassReiter]="true"
                    ></kiene-einstallen-uebersicht>
                </div>

                <div *ngIf="!showEinstallenOverview || !gruppe?.gruppe_id" class="dashboard-einstallen-stepper__state">
                    Bitte zuerst eine Gruppe auswählen.
                </div>

            </div>
        </mat-step>

        <mat-step
            *ngIf="isAusstallenFlow"
            [completed]="hasTierauswahlForAusstallen && maxVisitedStepIndex >= (ix.workflowAusstallen ?? 0)"
        >
            <ng-template matStepLabel>{{ ausstallenActionLabel }}</ng-template>

            <div
                *ngIf="
                    isContinueAbgangTierlisteMode
                        ? isActiveMaterialStep(ausstallenActionLabel)
                        : ix.workflowAusstallen !== null && isActiveStep(ix.workflowAusstallen)
                "
                class="dashboard-einstallen-stepper__step-body dashboard-einstallen-stepper__step-body--ausstallen-embedded"
            >
                <p *ngIf="!hasTierauswahlForAusstallen" class="dashboard-einstallen-stepper__state">
                    Bitte zuerst Tiere zur Liste hinzufügen.
                </p>
                <p *ngIf="hasTierauswahlForAusstallen && !ausstallenInput" class="dashboard-einstallen-stepper__state">
                    Formular wird vorbereitet…
                </p>

                <kiene-ausstallen-dialog
                    #embeddedAusstallen
                    *ngIf="hasTierauswahlForAusstallen && ausstallenInput"
                    [embeddedInStepper]="true"
                    [embeddedTitle]="ausstallenActionLabel"
                    [embeddedCreateButtonLabel]="embeddedAusstallenSubmitLabel"
                    [hideEmbeddedFooter]="true"
                    [stepperDialogInput]="ausstallenInput"
                    (ausstallenCompleted)="onAusstallenFormSaved($event)"
                    (ausstallenCancelled)="onAusstallenFormAborted()"
                    (tierlistePersisted)="onEmbeddedTierlistePersisted($event)"
                ></kiene-ausstallen-dialog>
            </div>
        </mat-step>

        <mat-step *ngIf="isEinstallenFlow">
            <ng-template matStepLabel>Prüfen & melden</ng-template>

            <div *ngIf="ix.review !== null && isEinstallenFlow && isActiveStep(ix.review)" class="dashboard-einstallen-stepper__step-body">
                <div class="dashboard-einstallen-stepper__selection-card" *ngIf="gruppe?.gruppe_id">
                    <div class="dashboard-einstallen-stepper__selection-label">Gruppe</div>
                    <div>{{ gruppe?.bezeichnung }}<span *ngIf="gruppe?.stall"> | {{ gruppe?.stall }}</span></div>
                </div>

                <div *ngIf="isLoadingReview" class="dashboard-einstallen-stepper__state">Lade Zusammenfassung...</div>

                <ng-container *ngIf="!isLoadingReview">
                    <div class="dashboard-einstallen-stepper__review-option">
                        <mat-checkbox [disabled]="overview.anzahlPassUndOhrmarke <= 0" [(ngModel)]="hitOptionen.passUndOhrmarke">
                            Ohrmarke und Pass gescannt ({{ overview.anzahlPassUndOhrmarke }} Stk.)
                        </mat-checkbox>
                    </div>

                    <div class="dashboard-einstallen-stepper__review-option">
                        <mat-checkbox [disabled]="overview.anzahlPass <= 0" [(ngModel)]="hitOptionen.nurPassGescannt">
                            nur Pass gescannt ({{ overview.anzahlPass }} Stk.)
                        </mat-checkbox>
                    </div>

                    <div class="dashboard-einstallen-stepper__review-option">
                        <mat-checkbox [disabled]="overview.anzahlOhrmarke <= 0" [(ngModel)]="hitOptionen.nurOhrmarkeGescannt">
                            nur Ohrmarke gescannt ({{ overview.anzahlOhrmarke }} Stk.)
                        </mat-checkbox>
                    </div>

                    <div class="dashboard-einstallen-stepper__review-option">
                        <mat-checkbox [disabled]="overview.anzahlCsv <= 0" [(ngModel)]="hitOptionen.wederPassNochOhrmarke">
                            nur CSV-Import ({{ overview.anzahlCsv }} Stk.)
                        </mat-checkbox>
                    </div>

                    <div *ngIf="canEditGewicht" class="dashboard-einstallen-stepper__selection-card">
                        <div class="dashboard-einstallen-stepper__selection-label">Tiere in dieser Liste</div>
                        <div class="dashboard-einstallen-stepper__summary-row">
                            <span>Anzahl</span>
                            <span>{{ last10SuccessfulScansCount }} Stk.</span>
                        </div>
                        <div class="dashboard-einstallen-stepper__summary-row" *ngIf="showLast10ScansGewicht">
                            <span>Gesamtgewicht</span>
                            <span>{{ last10ScansGesamtGewicht | number: "1.1-1" : "de" }} kg</span>
                        </div>
                        <div class="dashboard-einstallen-stepper__summary-warning" *ngIf="missingGewichteCount > 0">
                            Für {{ missingGewichteCount }} von {{ last10SuccessfulScansCount }} Tieren fehlt das
                            Einstallgewicht.
                        </div>
                        <div class="dashboard-einstallen-stepper__summary-actions" *ngIf="missingGewichteCount > 0">
                            <button mat-stroked-button color="accent" type="button" (click)="gewichteBearbeiten()">
                                Gewichte bearbeiten
                            </button>
                        </div>
                    </div>

                    <div *ngIf="overview.nichtMeldbar > 0" class="dashboard-einstallen-stepper__warning">
                        Tiere ohne Einstalldatum: {{ overview.nichtMeldbar }}
                    </div>
                </ng-container>

            </div>
        </mat-step>
    </mat-stepper>
        </div>

        <div
            *ngIf="isPrefillInitializing"
            class="dashboard-einstallen-stepper__init-loading dashboard-einstallen-stepper__init-loading--overlay"
            aria-live="polite"
        >
            <div class="dashboard-einstallen-stepper__init-loading-inner">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="dashboard-einstallen-stepper__init-loading-text">
                    {{ isContinueDirectScanMode ? 'Scans werden vorbereitet…' : 'Ausstallliste wird vorbereitet…' }}
                </p>
                <div class="dashboard-einstallen-stepper__init-skeleton" aria-hidden="true">
                    <div
                        class="dashboard-einstallen-stepper__init-skeleton-bar dashboard-einstallen-stepper__init-skeleton-bar--wide"
                    ></div>
                    <div class="dashboard-einstallen-stepper__init-skeleton-bar"></div>
                    <div
                        class="dashboard-einstallen-stepper__init-skeleton-bar dashboard-einstallen-stepper__init-skeleton-bar--short"
                    ></div>
                    <div class="dashboard-einstallen-stepper__init-skeleton-block"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div
    *ngIf="showStickyFooterNav"
    mat-dialog-actions
    class="dashboard-einstallen-stepper__footer"
>
    <span class="spacer"></span>
    <span *ngIf="ausstallenSaveBlockedMessage" class="dashboard-einstallen-stepper__footer-hint">{{
        ausstallenSaveBlockedMessage
    }}</span>
    <button *ngIf="showFooterBack" mat-button type="button" (click)="stepBack()">Zurück</button>
    <ng-container *ngIf="isReviewStepActive; else defaultFooterPrimary">
        <button
            mat-stroked-button
            color="accent"
            type="button"
            [disabled]="isLoadingReview || isSubmitting || isClosingTierliste"
            (click)="abschliessen()"
        >
            Abschliessen
        </button>
        <button
            mat-flat-button
            color="accent"
            type="button"
            [disabled]="isLoadingReview || isSubmitting || isClosingTierliste || !canSubmitMelden"
            (click)="submit()"
        >
            Abschliessen melden
        </button>
    </ng-container>
    <ng-template #defaultFooterPrimary>
        <button
            mat-flat-button
            color="accent"
            type="button"
            [disabled]="footerPrimaryDisabled"
            (click)="footerPrimaryClick()"
        >
            {{ footerPrimaryLabel }}
        </button>
    </ng-template>
</div>
